import { computed, provide, reactive } from "vue"
import { useRoute } from "vue-router";

// flows
import loadConfigService from "./flows/loadConfig"
import loadCampaignService from "./flows/loadCampaign"
import loadUserService from "./flows/loadUser"
import loadHistory from "./flows/loadHistory"

export const LandingFlow = function (options = {}) {
    const route = useRoute()

    const states = reactive({
        mainAppName: options?.mainAppName ?? "",
        campaign: null,
        profile: null,
        isLogin: false,
        blobWebLanding: null,
        blobUrl: "",
        query: null,
        appConfig: null,
        selectTier: {},
        purchase: null
    })

    const events = reactive({
        onReady: () => true,
        onError: () => true
    })

    const isPageReady = computed(() => {
        // check data is all load
        if (states.query != null && states.campaign != null && states.blobWebLanding != null && states.appConfig != null) {
            return true
        }
        return false
    })

    //#region methods
    const init = async function () {
        const configService = loadConfigService(states)
        const campaignService = loadCampaignService(states)
        const userService = loadUserService(states)
        const historyService = loadHistory(states)


        try {
            await configService.loadConfig()
            if (route.name != 'iimmpact_history') {
                await campaignService.loadCampaignDetail()
            }
            await userService.loadUserProfile()
            if (route.name == 'iimmpact_history') {
                await historyService.loadHistory()
            }

            events.onReady(isPageReady)
        } catch (error) {
            events.onError(error)
        }
    }

    const getters = {
        getUserPoint: function () {
            if (states.profile) {
                if (states.profile.updated_points?.points != null) {
                    let points = states.profile.updated_points.points
                    states.point = points
                    return states.point;
                }
                return 0
            } else {
                return 0;
            }
        },
    }
    const setters = {
        setCampaign: function (campaign) {
            states.campaign = campaign
        }
    }
    //#endregion

    provide("LandingStates", states)

    return {
        states,
        isPageReady,
        events,
        init,
        getters,
        setters,
    }
}

export default LandingFlow
